const ProfileButton = ({ user }) => {
  return user.isGuest ? (
    <a
      title={gettext("Create an account and save your points!")}
      href={user.convertUrl}
      className="flex justify-center bg-primary-700 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75"
    >
      <span>{user.username}</span>
    </a>
  ) : (
    <a
      title={gettext("Your account")}
      href={user.profileUrl}
      className="flex justify-center bg-primary-700 py-2 px-4 border border-transparent rounded-md text-base font-medium text-white hover:bg-opacity-75"
    >
      {user.avatar && (
        <img
          className="inline-block h-6 w-6 mr-2 rounded-full ring-2 ring-white object-cover"
          src={user.avatar}
          alt=""
        />
      )}
      <span>{user.username}</span>
    </a>
  );
};
export default ProfileButton;
